module.exports = __webpack_public_path__ + "static/media/vs.54ee36df.svg";